




















































import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME, BANNER_HEIGHT, BANNER_WIDTH, BASE64_PNG_PREFIX } from './constants';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dialogImageUrl: null,
			dialogVisible: false,
			fileList: [] as any[],
		};
	},
	methods: {
		async loadedData() {
			if (!this.isCreateMode && this.Banner) {
				const url = BASE64_PNG_PREFIX + this.Banner;
				this.fileList.push({ name: 'banner.png', url });
			}
		},
		handleRemove() {
			this.fileList = [];
			this.Banner = null;
		},
		handlePictureCardPreview(file: any) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		handleDownload(file: any) {
			const link = document.createElement('a');
			link.setAttribute('href', file.url);
			link.setAttribute('download', 'banner.png');
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		handleChange(file: any, fileList: []) {
			this.fileList = [];
			const fr = new FileReader();
			fr.onload = () => {
				const img = new Image();
				img.onload = () => {
					if (img.width > BANNER_WIDTH || img.height > BANNER_HEIGHT) {
						const message = `${this.LocalizePopisostatni('doporucenyHW_Baner')}. ${this.LocalizeChyboveHlasky('aktualWH_Banner')}
						${img.width} x ${img.height}px.`;
						this.showConfirm({ title: this.LocalizeChyboveHlasky('oznamTitle'), message, options: { showCancelButton: false } });
					}
					this.fileList = fileList;
					this.Banner = fr.result as string;
					this.Banner = this.Banner.replace(BASE64_PNG_PREFIX, '');
				};
				img.onerror = this.errorOpenFile;
				img.src = fr.result as string;
			};
			fr.onerror = this.errorOpenFile;
			fr.readAsDataURL(file.raw);
		},
		handlePreview(file: any) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		errorOpenFile() {
			this.showErrorNotification(this.LocalizeChyboveHlasky('CantOpenFile'));
		},
	},
});
